<template>
  <div v-if="chips.length" class="run-version-chips d-flex flex-wrap align-center">
    <v-tooltip v-for="chip in chips" :key="chip.key" bottom :disabled="!chip.tooltip">
      <template #activator="{ on, attrs }">
        <v-chip
          v-bind="attrs"
          :color="chip.color || undefined"
          :outlined="!!chip.outlined"
          :dark="!!chip.color && !chip.outlined"
          :x-small="dense"
          :small="!dense"
          label
          class="run-version-chip mr-1 mb-1"
          :class="[`run-version-chip--${chip.key}`, { 'run-version-chip--mono': chip.mono }]"
          v-on="on"
        >
          <v-icon v-if="chip.icon" left x-small>{{ chip.icon }}</v-icon>
          {{ chip.text }}
        </v-chip>
      </template>
      <span>{{ chip.tooltip }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { runVersionChips } from '@/utils/runLabels';

/**
 * Read-only chips describing a run: 'Active' / 'Pinned', engine versions, 'config vN · hash',
 * 'build <sha7>', 'partial' and 'degraded' (each with a tooltip). Renders nothing for legacy
 * results without a run block.
 */
export default {
  name: 'RunVersionChips',

  props: {
    /** metadata.run block or a ledger run document. */
    run: {
      type: Object,
      default: null,
    },
    /** 'interview' shows the interview engines too; anything else only gestures / coherence. */
    sourceType: {
      type: String,
      default: null,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    chips() {
      return runVersionChips(this.run, { sourceType: this.sourceType });
    },
  },
};
</script>

<style scoped>
.run-version-chip--mono {
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
  font-size: 0.72rem;
}
</style>
